import { Checkbox, Grid, Paper, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { CompactTable, StyledPaper } from "../commons"
import { BorrowAndLendingDataType, constructBorrowAndLendingTable, tableHeadersBorrow, tableHeadersDeposit } from "./table"
import { useState } from "react"

export interface BorrowAndLendingTableType {
  title: 'DEPOSITED' | 'BORROWED'
  data: BorrowAndLendingDataType[]
}

const HideAsset = (props: { callback: () => void }) => {
  return (
    <>
      <Checkbox sx={{ paddingLeft: 0 }} onChange={() => props.callback()} />
      <Typography variant="body4" color='text.primary' sx={{ verticalAlign: 'middle' }}>
        {'HIDE ASSETS (< $1)'}
      </Typography>
    </>
  )
}

// const EModeOption = () => {
//   return (
//     <>
//       <Typography variant="r" color='text.primary' sx={{ verticalAlign: 'middle' }}>
//         {'E-Mode'}
//       </Typography>
//       <Checkbox />
//     </>
//   )
// }

const BorrowAndLendingTable = (props: BorrowAndLendingTableType) => {
  const { title, data } = props
  const navigate = useNavigate()
  const [hideSmallAssets, setHideSmallAssets] = useState(false)
  const isDeposited = title === 'DEPOSITED'
  const isBorrowed = title === 'BORROWED'
  const tableHead = isDeposited ? tableHeadersDeposit : tableHeadersBorrow

  const handleHideSmallAmount = () => {
    setHideSmallAssets((prev) => !prev)
  }

  const optionUI = isDeposited ? <HideAsset callback={handleHideSmallAmount} /> : <div style={{ height: '2.5rem' }} />

  const filteredData = data.sort((a, b) => isDeposited ? b.supplyValue - a.supplyValue : b.borrowValue - a.borrowValue)
    .filter((data) => hideSmallAssets ? data.supplyValue >= 1 : true)
  const tableBorrowAndLendingData = constructBorrowAndLendingTable(filteredData, isDeposited, isBorrowed, navigate)

  return (
    <Grid item container>
      <StyledPaper color='primary' transparent sx={{
        // backgroundColor: '#283D3E', 
        minWidth: '12.8rem',
        width: '100%',
        borderRadius: 1,
        padding: '0px', //to show border
      }}>
        <Grid container flexDirection={'column'} gap={0}>
          <StyledPaper color='primary' sx={{
            padding: '1rem 1.5em',
            minWidth: '12.8rem',
            width: '100%',
            border: 0,
            borderRadius: 0
          }}>
            <Typography variant="h6" color='text.primary'>
              {title}
            </Typography>
          </StyledPaper>
          <Paper sx={{
            paddingTop: '1rem',
            width: '100%'
          }}>
            <Grid container alignItems={'center'}
              justifyContent={'flex-start'}>
              <Grid item sx={{ padding: '0rem 1.5rem' }}>
                {optionUI}
              </Grid>
              <Grid item sx={{ overflowX: 'auto', marginTop: 1.5 }}>
                <CompactTable tableHeader={tableHead} tableContent={tableBorrowAndLendingData} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </StyledPaper>
    </Grid >
  )
}

export default BorrowAndLendingTable